import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Auth } from './auth.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private auth: Auth, private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return Observable.create(observer => {
      this.auth.isAuthenticated().then(isAuthenticated => {
        console.log(isAuthenticated);

        if (isAuthenticated) {
          observer.next(true);
          observer.complete();
        } else {
          this.auth.returnUrl = state.url;
          this.router.navigate(['/login']);
          observer.next(false);
          observer.complete();
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.guard.ts